// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { StatementService, ResourceAction } from '@app/core';

export enum PolicyStatementActionTypes {
  SERVICES_LOADING = '[POLICY STATEMENT] SERVICES_LOADING',
  SERVICES_LOAD_COMPLETE = '[POLICY STATEMENT] SERVICES_LOAD_COMPLETE',
  SERVICES_LOAD_FAILED = '[POLICY STATEMENT] SERVICES_LOAD_FAILED',
  RESOURCE_ACTIONS_LOADING = '[POLICY STATEMENT] RESOURCE_ACTIONS_LOADING',
  RESOURCE_ACTIONS_LOAD_COMPLETE = '[POLICY STATEMENT] RESOURCE_ACTIONS_LOAD_COMPLETE',
  RESOURCE_ACTIONS_LOAD_FAILED = '[POLICY STATEMENT] RESOURCE_ACTIONS_LOAD_FAILED'
}

export class LoadingPolicyStatementServicesAction implements Action {
  readonly type = PolicyStatementActionTypes.SERVICES_LOADING;
  constructor() {}
}

export class CompleteLoadPolicyStatementServicesAction implements Action {
  readonly type = PolicyStatementActionTypes.SERVICES_LOAD_COMPLETE;
  constructor(public payload: { services: StatementService[] }) {}
}

export class FailLoadPolicyStatementServicesAction implements Action {
  readonly type = PolicyStatementActionTypes.SERVICES_LOAD_FAILED;
  constructor() {}
}

export class LoadingPolicyStatementResourceActionsAction implements Action {
  readonly type = PolicyStatementActionTypes.RESOURCE_ACTIONS_LOADING;
  constructor(public payload: { serviceId: string }) {}
}

export class CompleteLoadPolicyStatementResourceActionsAction implements Action {
  readonly type = PolicyStatementActionTypes.RESOURCE_ACTIONS_LOAD_COMPLETE;
  constructor(public payload: { serviceId: string; resourceActions: ResourceAction[] }) {}
}

export class FailLoadPolicyStatementResourceActionsAction implements Action {
  readonly type = PolicyStatementActionTypes.RESOURCE_ACTIONS_LOAD_FAILED;
  constructor(public payload: { serviceId: string }) {}
}

export type PolicyStatementActionsUnion =
  | LoadingPolicyStatementServicesAction
  | CompleteLoadPolicyStatementServicesAction
  | FailLoadPolicyStatementServicesAction
  | LoadingPolicyStatementResourceActionsAction
  | CompleteLoadPolicyStatementResourceActionsAction
  | FailLoadPolicyStatementResourceActionsAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-statement.actions.ts